<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <el-dialog title="风阀遥控" :visible.sync="remoteDialogVisible" width="30%">
      <el-link class="history-href" type="primary" href="/#/sutong/airValve/remoteHistory">历史记录</el-link>
      <el-form :model="remoteDialogModel" v-loading="remoteDialogLoading">
        <el-form-item class="dialog-form-item">
          <div class="dialog-form-key top-align">风阀名称</div>
          <div class="dialog-form-value">
            <p>{{ remoteDialogModel.airValveName1 }}</p>
            <p>{{ remoteDialogModel.airValveName2 }}</p>
          </div>
        </el-form-item>
        <el-form-item class="dialog-form-item">
          <div class="dialog-form-key">遥控指令</div>
          <el-switch
            v-model="remoteDialogModel.remoteCommand"
            active-text="开启风阀"
            inactive-text="关闭风阀"
            active-color="#67dd34"
            inactive-color="#a0a0a0"
            class="dialog-form-value"
          ></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remoteDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRemoteDialog">确 定</el-button>
      </span>
    </el-dialog>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>南通侧</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">风阀</div>
          <div class="sensor2">风阀</div>
        </div>
        <div class="legend-right">
          <div class="open">风阀开启</div>
          <div class="closed">风阀关闭</div>
          <div class="switching">风阀切换</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">南通</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">江侧</span>
        </div>
        <div class="cable-img nantong">
          <div class="clip sensor1 left1">
            <div :class="[nantongError1, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 1)" class="state-info right-pos">
              <p class="segment-name">NA32梁段</p>
              <p>
                <span>N1X</span>
                <el-tooltip :content="valveTooltipN1X" effect="light" placement="right">
                  <span :class="valveClassN1X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N1S</span>
                <el-tooltip :content="valveTooltipN1S" effect="light" placement="right">
                  <span :class="valveClassN1S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-1">
            <div :class="[nantongError2, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 2)" class="state-info right-pos">
              <p class="segment-name">NA28梁段</p>
              <p>
                <span>N2X</span>
                <el-tooltip :content="valveTooltipN2X" effect="light" placement="right">
                  <span :class="valveClassN2X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N2S</span>
                <el-tooltip :content="valveTooltipN2S" effect="light" placement="right">
                  <span :class="valveClassN2S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left2">
            <div :class="[nantongError3, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 3)" class="state-info right-pos">
              <p class="segment-name">NA24梁段</p>
              <p>
                <span>N3X</span>
                <el-tooltip :content="valveTooltipN3X" effect="light" placement="right">
                  <span :class="valveClassN3X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N3S</span>
                <el-tooltip :content="valveTooltipN3S" effect="light" placement="right">
                  <span :class="valveClassN3S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-2">
            <div :class="[nantongError4, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 4)" class="state-info right-pos">
              <p class="segment-name">NA21梁段</p>
              <p>
                <span>N4X</span>
                <el-tooltip :content="valveTooltipN4X" effect="light" placement="right">
                  <span :class="valveClassN4X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N4S</span>
                <el-tooltip :content="valveTooltipN4S" effect="light" placement="right">
                  <span :class="valveClassN4S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left3">
            <div :class="[nantongError5, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 5)" class="state-info right-pos">
              <p class="segment-name">NA18梁段</p>
              <p>
                <span>N5X</span>
                <el-tooltip :content="valveTooltipN5X" effect="light" placement="right">
                  <span :class="valveClassN5X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N5S</span>
                <el-tooltip :content="valveTooltipN5S" effect="light" placement="right">
                  <span :class="valveClassN5S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-3">
            <div :class="[nantongError6, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 6)" class="state-info right-pos">
              <p class="segment-name">NA14梁段</p>
              <p>
                <span>N6X</span>
                <el-tooltip :content="valveTooltipN6X" effect="light" placement="right">
                  <span :class="valveClassN6X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N6S</span>
                <el-tooltip :content="valveTooltipN6S" effect="light" placement="right">
                  <span :class="valveClassN6S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left4">
            <div :class="[nantongError7, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 7)" class="state-info right-pos">
              <p class="segment-name">NA10梁段</p>
              <p>
                <span>N7X</span>
                <el-tooltip :content="valveTooltipN7X" effect="light" placement="right">
                  <span :class="valveClassN7X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N7S</span>
                <el-tooltip :content="valveTooltipN7S" effect="light" placement="right">
                  <span :class="valveClassN7S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-4">
            <div :class="[nantongError8, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 8)" class="state-info right-pos">
              <p class="segment-name">NA7梁段</p>
              <p>
                <span>N8X</span>
                <el-tooltip :content="valveTooltipN8X" effect="light" placement="right">
                  <span :class="valveClassN8X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N8S</span>
                <el-tooltip :content="valveTooltipN8S" effect="light" placement="right">
                  <span :class="valveClassN8S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left5">
            <div :class="[nantongError9, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 9)" class="state-info right-pos">
              <p class="segment-name">NA4梁段</p>
              <p>
                <span>N9X</span>
                <el-tooltip :content="valveTooltipN9X" effect="light" placement="right">
                  <span :class="valveClassN9X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N9S</span>
                <el-tooltip :content="valveTooltipN9S" effect="light" placement="right">
                  <span :class="valveClassN9S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>

          <div class="clip sensor2 right-bottom-6">
            <div :class="[nantongError10, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 10)" class="state-info left-pos">
              <p class="segment-name">NJ4梁段</p>
              <p>
                <span>N10X</span>
                <el-tooltip :content="valveTooltipN10X" effect="light" placement="right">
                  <span :class="valveClassN10X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N10S</span>
                <el-tooltip :content="valveTooltipN10S" effect="light" placement="right">
                  <span :class="valveClassN10S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right5">
            <div :class="[nantongError11, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 11)" class="state-info left-pos">
              <p class="segment-name">NJ7梁段</p>
              <p>
                <span>N11X</span>
                <el-tooltip :content="valveTooltipN11X" effect="light" placement="right">
                  <span :class="valveClassN11X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N11S</span>
                <el-tooltip :content="valveTooltipN11S" effect="light" placement="right">
                  <span :class="valveClassN11S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-5">
            <div :class="[nantongError12, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 12)" class="state-info left-pos">
              <p class="segment-name">NJ10梁段</p>
              <p>
                <span>N12X</span>
                <el-tooltip :content="valveTooltipN12X" effect="light" placement="right">
                  <span :class="valveClassN12X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N12S</span>
                <el-tooltip :content="valveTooltipN12S" effect="light" placement="right">
                  <span :class="valveClassN12S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right4">
            <div :class="[nantongError13, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 13)" class="state-info left-pos">
              <p class="segment-name">NJ13梁段</p>
              <p>
                <span>N13X</span>
                <el-tooltip :content="valveTooltipN13X" effect="light" placement="right">
                  <span :class="valveClassN13X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N13S</span>
                <el-tooltip :content="valveTooltipN13S" effect="light" placement="right">
                  <span :class="valveClassN13S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-4">
            <div :class="[nantongError14, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 14)" class="state-info left-pos">
              <p class="segment-name">NJ16梁段</p>
              <p>
                <span>N14X</span>
                <el-tooltip :content="valveTooltipN14X" effect="light" placement="right">
                  <span :class="valveClassN14X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N14S</span>
                <el-tooltip :content="valveTooltipN14S" effect="light" placement="right">
                  <span :class="valveClassN14S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right3">
            <div :class="[nantongError15, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 15)" class="state-info left-pos">
              <p class="segment-name">NJ19梁段</p>
              <p>
                <span>N15X</span>
                <el-tooltip :content="valveTooltipN15X" effect="light" placement="right">
                  <span :class="valveClassN15X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N15S</span>
                <el-tooltip :content="valveTooltipN15S" effect="light" placement="right">
                  <span :class="valveClassN15S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-3">
            <div :class="[nantongError16, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 16)" class="state-info left-pos">
              <p class="segment-name">NJ22梁段</p>
              <p>
                <span>N16X</span>
                <el-tooltip :content="valveTooltipN16X" effect="light" placement="right">
                  <span :class="valveClassN16X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N16S</span>
                <el-tooltip :content="valveTooltipN16S" effect="light" placement="right">
                  <span :class="valveClassN16S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right2">
            <div :class="[nantongError17, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 17)" class="state-info left-pos">
              <p class="segment-name">NJ25梁段</p>
              <p>
                <span>N17X</span>
                <el-tooltip :content="valveTooltipN17X" effect="light" placement="right">
                  <span :class="valveClassN17X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N17S</span>
                <el-tooltip :content="valveTooltipN17S" effect="light" placement="right">
                  <span :class="valveClassN17S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-2">
            <div :class="[nantongError18, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 18)" class="state-info left-pos">
              <p class="segment-name">NJ28梁段</p>
              <p>
                <span>N18X</span>
                <el-tooltip :content="valveTooltipN18X" effect="light" placement="right">
                  <span :class="valveClassN18X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N18S</span>
                <el-tooltip :content="valveTooltipN18S" effect="light" placement="right">
                  <span :class="valveClassN18S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right1-higher">
            <div :class="[nantongError19, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 19)" class="state-info left-pos">
              <p class="segment-name">NJ31梁段</p>
              <p>
                <span>N19X</span>
                <el-tooltip :content="valveTooltipN19X" effect="light" placement="right">
                  <span :class="valveClassN19X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N19S</span>
                <el-tooltip :content="valveTooltipN19S" effect="light" placement="right">
                  <span :class="valveClassN19S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-1">
            <div :class="[nantongError20, isRemoteAvailable]" @click="airValveGroupClick('南通侧', 20)" class="state-info left-pos">
              <p class="segment-name">NJ34梁段</p>
              <p>
                <span>N20X</span>
                <el-tooltip :content="valveTooltipN20X" effect="light" placement="right">
                  <span :class="valveClassN20X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>N20S</span>
                <el-tooltip :content="valveTooltipN20S" effect="light" placement="right">
                  <span :class="valveClassN20S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>常熟侧</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">风阀</div>
          <div class="sensor2">风阀</div>
        </div>
        <div class="legend-right">
          <div class="open">风阀开启</div>
          <div class="closed">风阀关闭</div>
          <div class="switching">风阀切换</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">江侧</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">常熟</span>
        </div>
        <div class="cable-img changshu">
          <div class="clip sensor2 left-bottom-1">
            <div :class="[changshuError20, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 20)" class="state-info right-pos">
              <p class="segment-name">SJ34梁段</p>
              <p>
                <span>S20X</span>
                <el-tooltip :content="valveTooltipS20X" effect="light" placement="right">
                  <span :class="valveClassS20X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S20S</span>
                <el-tooltip :content="valveTooltipS20S" effect="light" placement="right" v-bind:disabled="t1">
                  <span :class="valveClassS20S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left1-higher">
            <div :class="[changshuError19, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 19)" class="state-info right-pos">
              <p class="segment-name">SJ31梁段</p>
              <p>
                <span>S19X</span>
                <el-tooltip :content="valveTooltipS19X" effect="light" placement="right">
                  <span :class="valveClassS19X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S19S</span>
                <el-tooltip :content="valveTooltipS19S" effect="light" placement="right">
                  <span :class="valveClassS19S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-2">
            <div :class="[changshuError18, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 18)" class="state-info right-pos">
              <p class="segment-name">SJ28梁段</p>
              <p>
                <span>S18X</span>
                <el-tooltip :content="valveTooltipS18X" effect="light" placement="right">
                  <span :class="valveClassS18X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S18S</span>
                <el-tooltip :content="valveTooltipS18S" effect="light" placement="right">
                  <span :class="valveClassS18S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left2">
            <div :class="[changshuError17, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 17)" class="state-info right-pos">
              <p class="segment-name">SJ25梁段</p>
              <p>
                <span>S17X</span>
                <el-tooltip :content="valveTooltipS17X" effect="light" placement="right">
                  <span :class="valveClassS17X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S17S</span>
                <el-tooltip :content="valveTooltipS17S" effect="light" placement="right">
                  <span :class="valveClassS17S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-3">
            <div :class="[changshuError16, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 16)" class="state-info right-pos">
              <p class="segment-name">SJ22梁段</p>
              <p>
                <span>S16X</span>
                <el-tooltip :content="valveTooltipS16X" effect="light" placement="right">
                  <span :class="valveClassS16X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S16S</span>
                <el-tooltip :content="valveTooltipS16S" effect="light" placement="right">
                  <span :class="valveClassS16S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left3">
            <div :class="[changshuError15, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 15)" class="state-info right-pos">
              <p class="segment-name">SJ19梁段</p>
              <p>
                <span>S15X</span>
                <el-tooltip :content="valveTooltipS15X" effect="light" placement="right">
                  <span :class="valveClassS15X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S15S</span>
                <el-tooltip :content="valveTooltipS15S" effect="light" placement="right">
                  <span :class="valveClassS15S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-4">
            <div :class="[changshuError14, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 14)" class="state-info right-pos">
              <p class="segment-name">SJ16梁段</p>
              <p>
                <span>S14X</span>
                <el-tooltip :content="valveTooltipS14X" effect="light" placement="right">
                  <span :class="valveClassS14X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S14S</span>
                <el-tooltip :content="valveTooltipS14S" effect="light" placement="right">
                  <span :class="valveClassS14S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left4">
            <div :class="[changshuError13, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 13)" class="state-info right-pos">
              <p class="segment-name">SJ13梁段</p>
              <p>
                <span>S13X</span>
                <el-tooltip :content="valveTooltipS13X" effect="light" placement="right">
                  <span :class="valveClassS13X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S13S</span>
                <el-tooltip :content="valveTooltipS13S" effect="light" placement="right">
                  <span :class="valveClassS13S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-5">
            <div :class="[changshuError12, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 12)" class="state-info right-pos">
              <p class="segment-name">SJ10梁段</p>
              <p>
                <span>S12X</span>
                <el-tooltip :content="valveTooltipS12X" effect="light" placement="right">
                  <span :class="valveClassS12X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S12S</span>
                <el-tooltip :content="valveTooltipS12S" effect="light" placement="right">
                  <span :class="valveClassS12S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 left5">
            <div :class="[changshuError11, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 11)" class="state-info right-pos">
              <p class="segment-name">SJ7梁段</p>
              <p>
                <span>S11X</span>
                <el-tooltip :content="valveTooltipS11X" effect="light" placement="right">
                  <span :class="valveClassS11X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S11S</span>
                <el-tooltip :content="valveTooltipS11S" effect="light" placement="right">
                  <span :class="valveClassS11S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 left-bottom-6">
            <div :class="[changshuError10, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 10)" class="state-info right-pos">
              <p class="segment-name">SJ4梁段</p>
              <p>
                <span>S10X</span>
                <el-tooltip :content="valveTooltipS10X" effect="light" placement="right">
                  <span :class="valveClassS10X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S10S</span>
                <el-tooltip :content="valveTooltipS10S" effect="light" placement="right">
                  <span :class="valveClassS10S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>

          <div class="clip sensor1 right5">
            <div :class="[changshuError9, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 9)" class="state-info left-pos">
              <p class="segment-name">SA4梁段</p>
              <p>
                <span>S9X</span>
                <el-tooltip :content="valveTooltipS9X" effect="light" placement="right">
                  <span :class="valveClassS9X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S9S</span>
                <el-tooltip :content="valveTooltipS9S" effect="light" placement="right">
                  <span :class="valveClassS9S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-4">
            <div :class="[changshuError8, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 8)" class="state-info left-pos">
              <p class="segment-name">SA7梁段</p>
              <p>
                <span>S8X</span>
                <el-tooltip :content="valveTooltipS8X" effect="light" placement="right">
                  <span :class="valveClassS8X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S8S</span>
                <el-tooltip :content="valveTooltipS8S" effect="light" placement="right">
                  <span :class="valveClassS8S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right4">
            <div :class="[changshuError7, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 7)" class="state-info left-pos">
              <p class="segment-name">SA10梁段</p>
              <p>
                <span>S7X</span>
                <el-tooltip :content="valveTooltipS7X" effect="light" placement="right">
                  <span :class="valveClassS7X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S7S</span>
                <el-tooltip :content="valveTooltipS7S" effect="light" placement="right">
                  <span :class="valveClassS7S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-3">
            <div :class="[changshuError6, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 6)" class="state-info left-pos">
              <p class="segment-name">SA14梁段</p>
              <p>
                <span>S6X</span>
                <el-tooltip :content="valveTooltipS6X" effect="light" placement="right">
                  <span :class="valveClassS6X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S6S</span>
                <el-tooltip :content="valveTooltipS6S" effect="light" placement="right">
                  <span :class="valveClassS6S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right3">
            <div :class="[changshuError5, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 5)" class="state-info left-pos">
              <p class="segment-name">SA18梁段</p>
              <p>
                <span>S5X</span>
                <el-tooltip :content="valveTooltipS5X" effect="light" placement="right">
                  <span :class="valveClassS5X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S5S</span>
                <el-tooltip :content="valveTooltipS5S" effect="light" placement="right">
                  <span :class="valveClassS5S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-2">
            <div :class="[changshuError4, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 4)" class="state-info left-pos">
              <p class="segment-name">SA21梁段</p>
              <p>
                <span>S4X</span>
                <el-tooltip :content="valveTooltipS4X" effect="light" placement="right">
                  <span :class="valveClassS4X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S4S</span>
                <el-tooltip :content="valveTooltipS4S" effect="light" placement="right">
                  <span :class="valveClassS4S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right2">
            <div :class="[changshuError3, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 3)" class="state-info left-pos">
              <p class="segment-name">SA24梁段</p>
              <p>
                <span>S3X</span>
                <el-tooltip :content="valveTooltipS3X" effect="light" placement="right">
                  <span :class="valveClassS3X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S3S</span>
                <el-tooltip :content="valveTooltipS3S" effect="light" placement="right">
                  <span :class="valveClassS3S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor2 right-bottom-1">
            <div :class="[changshuError2, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 2)" class="state-info left-pos">
              <p class="segment-name">SA28梁段</p>
              <p>
                <span>S2X</span>
                <el-tooltip :content="valveTooltipS2X" effect="light" placement="right">
                  <span :class="valveClassS2X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S2S</span>
                <el-tooltip :content="valveTooltipS2S" effect="light" placement="right">
                  <span :class="valveClassS2S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
          <div class="clip sensor1 right1">
            <div :class="[changshuError1, isRemoteAvailable]" @click="airValveGroupClick('常熟侧', 1)" class="state-info left-pos">
              <p class="segment-name">SA32梁段</p>
              <p>
                <span>S1X</span>
                <el-tooltip :content="valveTooltipS1X" effect="light" placement="right">
                  <span :class="valveClassS1X" class="valve-sign"></span>
                </el-tooltip>
              </p>
              <p>
                <span>S1S</span>
                <el-tooltip :content="valveTooltipS1S" effect="light" placement="right">
                  <span :class="valveClassS1S" class="valve-sign"></span>
                </el-tooltip>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FullScreenDialog ref="tempDialog" :message="'远程遥控模块整体升级, 遥控功能暂停使用.'"></FullScreenDialog>
  </div>
</template>

<script>
export default {
  name: "airValve",
  data() {
    return {
      loading: true,
      timer: null,
      t1: true,
      hasRemoteMissionInProgress: false,
      routeName: "",
      // isRemoteAvailable: 'remote-available',
      isRemoteAvailable: "",
      remoteDialogVisible: false,
      remoteDialogLoading: false,
      remoteDialogModel: {
        airValveName1: "",
        airValveName2: "",
        dataName1: "",
        dataName2: "",
        remoteCommand: false,
        errorName: "",
        error: "",
        dataDeviceId1: "",
        dataDeviceId2: "",
      },

      valveClassN1X: "",
      valveClassN1S: "",
      valveClassN2X: "",
      valveClassN2S: "",
      valveClassN3X: "",
      valveClassN3S: "",
      valveClassN4X: "",
      valveClassN4S: "",
      valveClassN5X: "",
      valveClassN5S: "",
      valveClassN6X: "",
      valveClassN6S: "",
      valveClassN7X: "",
      valveClassN7S: "",
      valveClassN8X: "",
      valveClassN8S: "",
      valveClassN9X: "",
      valveClassN9S: "",
      valveClassN10X: "",
      valveClassN10S: "",
      valveClassN11X: "",
      valveClassN11S: "",
      valveClassN12X: "",
      valveClassN12S: "",
      valveClassN13X: "",
      valveClassN13S: "",
      valveClassN14X: "",
      valveClassN14S: "",
      valveClassN15X: "",
      valveClassN15S: "",
      valveClassN16X: "",
      valveClassN16S: "",
      valveClassN17X: "",
      valveClassN17S: "",
      valveClassN18X: "",
      valveClassN18S: "",
      valveClassN19X: "",
      valveClassN19S: "",
      valveClassN20X: "",
      valveClassN20S: "",

      valveClassS1X: "",
      valveClassS1S: "",
      valveClassS2X: "",
      valveClassS2S: "",
      valveClassS3X: "",
      valveClassS3S: "",
      valveClassS4X: "",
      valveClassS4S: "",
      valveClassS5X: "",
      valveClassS5S: "",
      valveClassS6X: "",
      valveClassS6S: "",
      valveClassS7X: "",
      valveClassS7S: "",
      valveClassS8X: "",
      valveClassS8S: "",
      valveClassS9X: "",
      valveClassS9S: "",
      valveClassS10X: "",
      valveClassS10S: "",
      valveClassS11X: "",
      valveClassS11S: "",
      valveClassS12X: "",
      valveClassS12S: "",
      valveClassS13X: "",
      valveClassS13S: "",
      valveClassS14X: "",
      valveClassS14S: "",
      valveClassS15X: "",
      valveClassS15S: "",
      valveClassS16X: "",
      valveClassS16S: "",
      valveClassS17X: "",
      valveClassS17S: "",
      valveClassS18X: "",
      valveClassS18S: "",
      valveClassS19X: "",
      valveClassS19S: "",
      valveClassS20X: "",
      valveClassS20S: "",

      valveTooltipN1X: "",
      valveTooltipN1S: "",
      valveTooltipN2X: "",
      valveTooltipN2S: "",
      valveTooltipN3X: "",
      valveTooltipN3S: "",
      valveTooltipN4X: "",
      valveTooltipN4S: "",
      valveTooltipN5X: "",
      valveTooltipN5S: "",
      valveTooltipN6X: "",
      valveTooltipN6S: "",
      valveTooltipN7X: "",
      valveTooltipN7S: "",
      valveTooltipN8X: "",
      valveTooltipN8S: "",
      valveTooltipN9X: "",
      valveTooltipN9S: "",
      valveTooltipN10X: "",
      valveTooltipN10S: "",
      valveTooltipN11X: "",
      valveTooltipN11S: "",
      valveTooltipN12X: "",
      valveTooltipN12S: "",
      valveTooltipN13X: "",
      valveTooltipN13S: "",
      valveTooltipN14X: "",
      valveTooltipN14S: "",
      valveTooltipN15X: "",
      valveTooltipN15S: "",
      valveTooltipN16X: "",
      valveTooltipN16S: "",
      valveTooltipN17X: "",
      valveTooltipN17S: "",
      valveTooltipN18X: "",
      valveTooltipN18S: "",
      valveTooltipN19X: "",
      valveTooltipN19S: "",
      valveTooltipN20X: "",
      valveTooltipN20S: "",

      valveTooltipS1X: "",
      valveTooltipS1S: "",
      valveTooltipS2X: "",
      valveTooltipS2S: "",
      valveTooltipS3X: "",
      valveTooltipS3S: "",
      valveTooltipS4X: "",
      valveTooltipS4S: "",
      valveTooltipS5X: "",
      valveTooltipS5S: "",
      valveTooltipS6X: "",
      valveTooltipS6S: "",
      valveTooltipS7X: "",
      valveTooltipS7S: "",
      valveTooltipS8X: "",
      valveTooltipS8S: "",
      valveTooltipS9X: "",
      valveTooltipS9S: "",
      valveTooltipS10X: "",
      valveTooltipS10S: "",
      valveTooltipS11X: "",
      valveTooltipS11S: "",
      valveTooltipS12X: "",
      valveTooltipS12S: "",
      valveTooltipS13X: "",
      valveTooltipS13S: "",
      valveTooltipS14X: "",
      valveTooltipS14S: "",
      valveTooltipS15X: "",
      valveTooltipS15S: "",
      valveTooltipS16X: "",
      valveTooltipS16S: "",
      valveTooltipS17X: "",
      valveTooltipS17S: "",
      valveTooltipS18X: "",
      valveTooltipS18S: "",
      valveTooltipS19X: "",
      valveTooltipS19S: "",
      valveTooltipS20X: "",
      valveTooltipS20S: "",

      nantongError1: "",
      nantongError2: "",
      nantongError3: "",
      nantongError4: "",
      nantongError5: "",
      nantongError6: "",
      nantongError7: "",
      nantongError8: "",
      nantongError9: "",
      nantongError10: "",
      nantongError11: "",
      nantongError12: "",
      nantongError13: "",
      nantongError14: "",
      nantongError15: "",
      nantongError16: "",
      nantongError17: "",
      nantongError18: "",
      nantongError19: "",
      nantongError20: "",

      changshuError1: "",
      changshuError2: "",
      changshuError3: "",
      changshuError4: "",
      changshuError5: "",
      changshuError6: "",
      changshuError7: "",
      changshuError8: "",
      changshuError9: "",
      changshuError10: "",
      changshuError11: "",
      changshuError12: "",
      changshuError13: "",
      changshuError14: "",
      changshuError15: "",
      changshuError16: "",
      changshuError17: "",
      changshuError18: "",
      changshuError19: "",
      changshuError20: "",

      valueClassNameTranslateDict_remote: {
        0: "switching",
        1: "closed",
        2: "open",
      },
      valueClassnameTranslateDict_switch: {
        0: "open",
        1: "closed",
      },
      valueTooltipTranslateDict_remote: {
        0: "移动中",
        1: "关闭",
        2: "开启",
      },
      valueTooltipTranslateDict_switch: {
        0: "开启",
        1: "关闭",
      },
      dataNameIdDict_remote: {
        valveClassN1X: "233c4988-3bbe-4a39-bcb4-39cbb55a39ae",
        valveClassN1S: "e9b5a79f-5c7e-4d4b-8831-63a947ea466d",
        valveClassN2X: "9305f402-0438-4b02-987b-11041e33e423",
        valveClassN2S: "bc798660-7d0b-4d69-90e7-90823c06aa11",
        valveClassN3X: "c556a965-90a5-48dc-a8ed-dadbefa21c22",
        valveClassN3S: "e074de32-3b36-4021-abd6-509754b5c185",
        valveClassN4X: "6fd9beee-dbaf-4864-86a5-1de7b16620dd",
        valveClassN4S: "743d131f-1ffc-4da0-a9dd-4de0945fc7a2",
        valveClassN5X: "aaca8962-cc33-4c6d-a872-d871ed5230a2",
        valveClassN5S: "4b3e04d9-a408-4c84-aa5e-8c261d07bfa4",
        valveClassN6X: "1024c51b-3a55-4dff-81ab-e76a182a3fb0",
        valveClassN6S: "d73633ed-271b-4565-8826-0c2011380d69",
        valveClassN7X: "9bc0c899-e919-4638-b113-774553b9138e",
        valveClassN7S: "bd1a9644-b7bd-4ce8-ab0e-3b6a981a8a02",
        valveClassN8X: "fbe78288-e4cd-440b-8a5f-e746b18346bc",
        valveClassN8S: "57b348ee-585b-4c99-95f2-b95fbb593f71",
        valveClassN9X: "9a306edc-8929-4e36-b844-2b3ad50452dd",
        valveClassN9S: "464de33c-bdbc-4acf-a336-a6abe37b1eb6",
        valveClassN10X: "b23cfca9-a628-4f82-bb79-31aa9ad627f8",
        valveClassN10S: "d9971996-0f33-4bd9-abfc-2a3340da2eb6",
        valveClassN11X: "0c8ef3b8-1716-4f32-9f99-63f6c9eab3e8",
        valveClassN11S: "55e57d04-67e7-47ac-b10c-5dc1fa4cc3b1",
        valveClassN12X: "02164e35-17c1-4680-bc88-b0ecb9331e26",
        valveClassN12S: "6d3767d8-ca91-48a7-b797-1e9d7fcfd35d",
        valveClassN13X: "f2d4068b-2ca1-4a55-b983-f64738771b60",
        valveClassN13S: "fd5323e1-c7b7-48b5-bd11-3a9ddf20d147",
        valveClassN14X: "fd1e0350-e3e8-48dc-b336-0e97babe881b",
        valveClassN14S: "1cd78bd0-43e2-41fd-8104-c8fb32114de9",
        valveClassN15X: "198d023d-ec18-4047-8175-50582088ad3b",
        valveClassN15S: "4f10881d-f496-442d-ac41-4e5c25e94f18",
        valveClassN16X: "71fa9224-8218-4590-81dd-cd68f4a290c1",
        valveClassN16S: "d9c9737a-f70d-4975-bf62-a332808308b0",
        valveClassN17X: "8afdcc13-25c3-4061-80ef-67300d773363",
        valveClassN17S: "412659d7-d09a-452b-af8d-ef7bd79918ad",
        valveClassN18X: "fe1449a5-0d6c-44f0-9248-13b8b1d6afd3",
        valveClassN18S: "5527e2bf-d70e-4674-8fd2-02a0db641931",
        valveClassN19X: "e80714fe-5127-4af3-8ad0-511531e16b49",
        valveClassN19S: "1bf18640-ca43-414e-8eb9-6594da279656",
        valveClassN20X: "d6ec6a10-91b2-43bb-ba77-21d758db91ec",
        valveClassN20S: "6b95f73d-065d-4004-a105-dbe9a6086e28",

        valveClassS1X: "2fb9d5f6-6f6f-476a-bbbe-91dd3101cc63",
        valveClassS1S: "55e9d3a0-d6ea-4178-866d-612ab9e80839",
        valveClassS2X: "4f46c31c-4902-4b53-bdf9-c59aac61ff50",
        valveClassS2S: "ac694357-989b-4dd9-9447-7b8b277565d3",
        valveClassS3X: "429828b5-c915-4321-9937-706fd5575af1",
        valveClassS3S: "8258e91e-461a-4c69-bdf9-ed11a9ced6a4",
        valveClassS4X: "53ddd5e9-c648-45ce-9df9-d72410e3cc11",
        valveClassS4S: "8de2684f-3a54-4a18-a85b-a518c6d9718a",
        valveClassS5X: "c6296492-7bbd-4fad-86d4-71482be1336a",
        valveClassS5S: "da7482ed-de83-4417-865c-4dabdc0100f5",
        valveClassS6X: "e5d13e7f-ae18-457f-9d98-31405152a855",
        valveClassS6S: "fa4bf508-7e5f-4f9d-a14b-501c73770aae",
        valveClassS7X: "94256aeb-4448-40fd-a74e-609ba2e34340",
        valveClassS7S: "51c1e1a9-9ef9-4099-970f-e5a3d323ebc0",
        valveClassS8X: "fe6ac532-0c29-4d7d-a646-32d4a837edd3",
        valveClassS8S: "f536681c-f1bc-400c-95a9-837ab4453a7e",
        valveClassS9X: "babfa17c-4f95-4e19-a437-eda37a32fb33",
        valveClassS9S: "9c295af3-8ce8-4c8b-8f3b-887cdb195e21",
        valveClassS10X: "c6b1ef8d-eb45-44d3-b261-5785aea08de9",
        valveClassS10S: "4cb2b5a3-be2b-4e10-a0f4-90390830a4f9",
        valveClassS11X: "aee12d57-9b04-45c1-a331-22595b456df2",
        valveClassS11S: "5d856b55-afdc-4fd7-a146-82402821b300",
        valveClassS12X: "e55599e8-ed09-41f6-a9b5-8563ec5a7818",
        valveClassS12S: "ca9f0d8e-31a7-47ec-ba80-ca9c2738a071",
        valveClassS13X: "37c5d16e-c7c0-4bec-829f-343eb8774058",
        valveClassS13S: "7f82936a-190c-4218-8432-9d900e153b12",
        valveClassS14X: "6cad5811-3473-4405-bb79-81539d57131b",
        valveClassS14S: "b322ef11-80d4-4257-8566-dbb993cd9074",
        valveClassS15X: "119bd544-e86c-4f96-bc6f-6a5f595ef3f0",
        valveClassS15S: "c7b1632b-7fe9-404b-add8-cd3696c85d49",
        valveClassS16X: "b90aa11b-40b5-4e32-8c1c-dacbb9a66eb7",
        valveClassS16S: "3f760731-30a1-4f24-8e24-d0c1b08eaa66",
        valveClassS17X: "68ec534b-d2aa-4709-99d9-6e236730e246",
        valveClassS17S: "1b67650d-7709-4863-88e7-0ad74eb208dd",
        valveClassS18X: "b54671af-a5ac-4eb1-9b5f-bb8670b6b3e3",
        valveClassS18S: "6ee12ce6-3c6c-4f79-abb2-0205552ccda5",
        valveClassS19X: "3153c0b5-d1b7-4d0d-b5a1-1d1e3730978a",
        valveClassS19S: "ecf01e5b-206e-4743-a0c6-83896be9a545",
        valveClassS20X: "0641237c-f383-4232-94cb-78ba0e59c129",
        valveClassS20S: "10684599-0ef0-4d28-9730-d3e6cc29fd1f",
      },
      dataNameIdDict_switch: {
        valveClassN1X: "2996fdd9-68ed-4187-99ac-f039e98c7a66",
        valveClassN1S: "60107cfe-0ae3-4669-8f14-8d820ff81476",
        valveClassN2X: "6e895a3a-d446-405e-90a5-d05e77829ea3",
        valveClassN2S: "5e271e19-1c8f-47ac-a68c-055dc14db329",
        valveClassN3X: "cb017abf-3563-4768-8b86-5539c6992377",
        valveClassN3S: "11ddf82c-f490-49d7-9544-4fb2c70bb9ba",
        valveClassN4X: "098e01b1-be6e-4459-8da8-21c8999caa3c",
        valveClassN4S: "3efd03b6-16ac-4319-9554-4e25756d281c",
        valveClassN5X: "9ad3afe6-e060-4840-b876-2ba22bb8964f",
        valveClassN5S: "e340500f-eff8-49f0-afb9-aa1665ddb1ab",
        valveClassN6X: "50ab2f3f-07de-44e9-8823-c65563d21434",
        valveClassN6S: "afdd43c8-b60d-4769-aef8-7ed7fa1cf1ed",
        valveClassN7X: "3f58228c-498e-4e1a-aa50-d8c76a3f5053",
        valveClassN7S: "a96f0431-3659-4cb5-99cb-065c24f1bd9a",
        valveClassN8X: "7f958ecd-e66a-49ad-af50-0340e128cbc8",
        valveClassN8S: "e97a4373-ece0-4ac3-988d-9531e0b4a833",
        valveClassN9X: "be2b1113-94eb-467b-afaf-c9366f7b2e72",
        valveClassN9S: "b07c8810-533d-4276-be88-ee32f8b34f82",
        valveClassN10X: "086e9232-7d34-4331-9ae1-1e70e24bc1b0",
        valveClassN10S: "cbdf18e1-42af-459e-bfc4-4bb9dbbcde46",
        valveClassN11X: "7e272663-5f8c-4108-8c21-e441c24e3fed",
        valveClassN11S: "344ad9f7-df28-4774-9994-6323d9cc9bff",
        valveClassN12X: "51751ebc-b60f-4a78-8c3c-12ff5ea4499d",
        valveClassN12S: "5e7c9301-9e07-44b7-9081-19ec8308d943",
        valveClassN13X: "04cd2687-2c99-4ffb-978c-cdc584465c2f",
        valveClassN13S: "39e812ea-15ad-4ad8-a7fe-35992827c3c6",
        valveClassN14X: "bd513a0a-77af-4ecf-835d-3f275415819c",
        valveClassN14S: "cccdd1c1-04d9-47e2-9994-6c2fe886f04e",
        valveClassN15X: "5c922d5c-04c1-4760-8b8b-c07accf0baac",
        valveClassN15S: "f14a5e8e-fd29-4be2-bbca-505af5e4b3f7",
        valveClassN16X: "34de1698-cd4d-4dc9-8801-84e1a3ea4c89",
        valveClassN16S: "5c307b80-cf97-40d9-8e3f-68552e1a30fc",
        valveClassN17X: "8aa93dd9-9fa0-4d35-be78-a778b3bcea50",
        valveClassN17S: "7fbe2fc5-2108-4a23-a264-99fedc26e462",
        valveClassN18X: "48853540-0d98-40af-b75e-d3c48d975b8b",
        valveClassN18S: "22a0014b-15e6-49ea-bbf3-cac21c5836fe",
        valveClassN19X: "36f92e4c-0879-46cf-bea4-151854d08013",
        valveClassN19S: "3f59f345-bfb9-46cb-ba9f-0948d16e1951",
        valveClassN20X: "b18ea915-047d-4a65-abbf-ad4cb6a90691",
        valveClassN20S: "ad885c9d-e4b7-44ab-94bd-90286a5fd8d1",

        valveClassS1X: "01771e33-55c6-483b-8e82-506e5d751f02",
        valveClassS1S: "24d00879-aa00-48bf-bd86-26fdba3680ca",
        valveClassS2X: "75d7259c-cf8d-4678-ae36-ac58f47732c4",
        valveClassS2S: "65a13028-92e9-463a-93ac-437d4dbe7217",
        valveClassS3X: "4ff93620-31b7-4a14-bdbd-c90fb6f74aca",
        valveClassS3S: "8e14fd52-c047-4a5b-8851-1e9883b87c15",
        valveClassS4X: "bbb1b28f-e639-49dd-9b4a-cf8d2f6d5215",
        valveClassS4S: "57fcd0b0-b54a-430e-ae30-6a952afe95e2",
        valveClassS5X: "f9ca938c-c55b-4fe5-8640-2b707d5363b5",
        valveClassS5S: "2fbfb223-06cd-49c9-a0fe-c85853848e4d",
        valveClassS6X: "f8f6903c-83ca-43e0-84db-c90ec5330dba",
        valveClassS6S: "05421a79-15f6-4909-af06-984696d6f689",
        valveClassS7X: "f908dbcb-f28e-4f62-ba1d-14924ea08c39",
        valveClassS7S: "bf7ba67f-9803-44d5-88a5-91260b1765ce",
        valveClassS8X: "792f121a-9130-4698-94f6-e3b43f672e8a",
        valveClassS8S: "9a5eb255-8572-42b3-934f-1b3f8ea9faea",
        valveClassS9X: "07b12557-c3ee-4434-8a2d-579733a6adc7",
        valveClassS9S: "1588fadc-b822-4f89-9659-31d3a3b16803",
        valveClassS10X: "140b248e-43d9-4705-a2d0-2c5f04e90db8",
        valveClassS10S: "a6779dfc-c38b-4192-856a-74180b7e8fce",
        valveClassS11X: "9f8ee3b8-8520-4018-98ee-2835d4aa9256",
        valveClassS11S: "53e11daa-09e6-4c86-b9b0-4b0bfe34969d",
        valveClassS12X: "637e7157-0f7e-4567-8ec7-65364b526803",
        valveClassS12S: "547ebeda-1972-443d-82ab-cb543383d91f",
        valveClassS13X: "f753d581-8111-4509-a3c9-f1eef062438b",
        valveClassS13S: "c40b15ea-f8ed-4d08-a735-d7dfd816b843",
        valveClassS14X: "235e0824-2a05-48a1-b2b2-1ad2ebb8a9f9",
        valveClassS14S: "3a0671a2-450a-4d46-a2f3-cb01452cf6ff",
        valveClassS15X: "3476745c-dcd4-4e44-a1a9-f647e816f847",
        valveClassS15S: "bc073d6d-77ca-4eca-b40f-646c3606fd66",
        valveClassS16X: "81bfaa39-9392-4d15-984e-f7ade39a5205",
        valveClassS16S: "d9556c98-57e5-42cf-b0ef-5673886989b1",
        valveClassS17X: "0f876b06-76c4-4deb-b3a6-8787fb4990ee",
        valveClassS17S: "22d4620f-96c8-4089-b2ff-06d286ae9f99",
        valveClassS18X: "d098801d-1f91-4394-8fe8-79bd5b698924",
        valveClassS18S: "fc6d09e4-f4f7-41cb-9944-48f9ca6415c3",
        valveClassS19X: "1db63125-a185-4bd8-acd4-d2ce0b22759e",
        valveClassS19S: "23545477-c42d-467d-8607-cbdcc4cd24a9",
        valveClassS20X: "8de15e9b-44f8-4553-8e7b-e7224702d45f",
        valveClassS20S: "ac49900c-7e06-4526-a17b-5aff3a275ff2",
      },
      dataNameErrorNameDict: {
        valveClassN1X: "nantongError1",
        valveClassN1S: "nantongError1",
        valveClassN2X: "nantongError2",
        valveClassN2S: "nantongError2",
        valveClassN3X: "nantongError3",
        valveClassN3S: "nantongError3",
        valveClassN4X: "nantongError4",
        valveClassN4S: "nantongError4",
        valveClassN5X: "nantongError5",
        valveClassN5S: "nantongError5",
        valveClassN6X: "nantongError6",
        valveClassN6S: "nantongError6",
        valveClassN7X: "nantongError7",
        valveClassN7S: "nantongError7",
        valveClassN8X: "nantongError8",
        valveClassN8S: "nantongError8",
        valveClassN9X: "nantongError9",
        valveClassN9S: "nantongError9",
        valveClassN10X: "nantongError10",
        valveClassN10S: "nantongError10",
        valveClassN11X: "nantongError11",
        valveClassN11S: "nantongError11",
        valveClassN12X: "nantongError12",
        valveClassN12S: "nantongError12",
        valveClassN13X: "nantongError13",
        valveClassN13S: "nantongError13",
        valveClassN14X: "nantongError14",
        valveClassN14S: "nantongError14",
        valveClassN15X: "nantongError15",
        valveClassN15S: "nantongError15",
        valveClassN16X: "nantongError16",
        valveClassN16S: "nantongError16",
        valveClassN17X: "nantongError17",
        valveClassN17S: "nantongError17",
        valveClassN18X: "nantongError18",
        valveClassN18S: "nantongError18",
        valveClassN19X: "nantongError19",
        valveClassN19S: "nantongError19",
        valveClassN20X: "nantongError20",
        valveClassN20S: "nantongError20",

        valveClassS1X: "changshuError1",
        valveClassS1S: "changshuError1",
        valveClassS2X: "changshuError2",
        valveClassS2S: "changshuError2",
        valveClassS3X: "changshuError3",
        valveClassS3S: "changshuError3",
        valveClassS4X: "changshuError4",
        valveClassS4S: "changshuError4",
        valveClassS5X: "changshuError5",
        valveClassS5S: "changshuError5",
        valveClassS6X: "changshuError6",
        valveClassS6S: "changshuError6",
        valveClassS7X: "changshuError7",
        valveClassS7S: "changshuError7",
        valveClassS8X: "changshuError8",
        valveClassS8S: "changshuError8",
        valveClassS9X: "changshuError9",
        valveClassS9S: "changshuError9",
        valveClassS10X: "changshuError10",
        valveClassS10S: "changshuError10",
        valveClassS11X: "changshuError11",
        valveClassS11S: "changshuError11",
        valveClassS12X: "changshuError12",
        valveClassS12S: "changshuError12",
        valveClassS13X: "changshuError13",
        valveClassS13S: "changshuError13",
        valveClassS14X: "changshuError14",
        valveClassS14S: "changshuError14",
        valveClassS15X: "changshuError15",
        valveClassS15S: "changshuError15",
        valveClassS16X: "changshuError16",
        valveClassS16S: "changshuError16",
        valveClassS17X: "changshuError17",
        valveClassS17S: "changshuError17",
        valveClassS18X: "changshuError18",
        valveClassS18S: "changshuError18",
        valveClassS19X: "changshuError19",
        valveClassS19S: "changshuError19",
        valveClassS20X: "changshuError20",
        valveClassS20S: "changshuError20",
      },
      stationIdList: ["63bbdd80-260d-4d33-967f-b45e94c8dfa7", "bc4d93d0-219b-4170-89aa-ce05ea70e871"],
    };
  },
  computed: {},
  mounted() {
    this.readRoute();
    this.getData();
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
      this.readRoute();
      this.loading = true;
      this.getData();
    },
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    historyHrefClick() {
      this.$route.push("/sutong/airValve/remoteHistory");
    },
    airValveGroupClick(groupName, groupIndex) {
      if (this.routeName !== "airValveRemote") {
        return;
      }

      this.resetRemoteDialog();

      //process name prefix
      let airValveNamePrefix = groupName;
      let dataNamePrefix = "valveClass";
      let errorNamePrefix = "";
      if (groupName === "南通侧") {
        airValveNamePrefix = airValveNamePrefix + "风阀N";
        dataNamePrefix = dataNamePrefix + "N";
        errorNamePrefix = errorNamePrefix + "nantongError";
      } else if (groupName === "常熟侧") {
        airValveNamePrefix = airValveNamePrefix + "风阀S";
        dataNamePrefix = dataNamePrefix + "S";
        errorNamePrefix = errorNamePrefix + "changshuError";
      }

      //procee air valve name
      this.remoteDialogModel.airValveName1 = airValveNamePrefix + groupIndex.toString() + "X";
      this.remoteDialogModel.airValveName2 = airValveNamePrefix + groupIndex.toString() + "S";

      //process data name
      this.remoteDialogModel.dataName1 = dataNamePrefix + groupIndex.toString() + "X";
      this.remoteDialogModel.dataName2 = dataNamePrefix + groupIndex.toString() + "S";

      //process remote command
      this.remoteDialogModel.remoteCommand = false;
      if (this[this.remoteDialogModel.dataName1] === "open" || this[this.remoteDialogModel.dataName2] === "open") {
        this.remoteDialogModel.remoteCommand = true;
      }

      //proces error
      this.remoteDialogModel.errorName = errorNamePrefix + groupIndex.toString();
      this.remoteDialogModel.error = this[this.remoteDialogModel.errorName];
      if (this.remoteDialogModel.error === "Warning") {
        this.$message({
          message: "风阀通信中断, 无法下发遥控指令",
          type: "warning",
        });
        return;
      }

      //process device id
      this.remoteDialogModel.dataDeviceId1 = this.dataNameIdDict_remote[this.remoteDialogModel.dataName1];
      this.remoteDialogModel.dataDeviceId2 = this.dataNameIdDict_remote[this.remoteDialogModel.dataName2];

      this.remoteDialogVisible = true;
    },
    submitRemoteDialog() {
      this.$refs["tempDialog"].show();
      return;

      if (
        this.remoteDialogModel.dataDeviceId1 === undefined ||
        this.remoteDialogModel.dataDeviceId2 === undefined ||
        this.remoteDialogModel.dataDeviceId1 === "" ||
        this.remoteDialogModel.dataDeviceId2 === ""
      ) {
        this.$message({
          message: "遥控设备ID为空",
          type: "warning",
        });
        return;
      }

      let command = {};
      command[this.remoteDialogModel.dataDeviceId1] = this.remoteDialogModel.remoteCommand;
      command[this.remoteDialogModel.dataDeviceId2] = this.remoteDialogModel.remoteCommand;

      let postBody = {
        deviceCommandDict: command,
      };

      this.remoteDialogLoading = true;
      this.$http
        .post("/remoteControl/SubmitNewMission", postBody)
        .then((res) => {
          this.$message({
            message: "任务提交成功, 请等待执行结果",
            type: "success",
          });
          this.resetRemoteDialog();
          this.remoteDialogVisible = false;
          this.refreshData();
        })
        .catch((error) => {
          console.log("error", error);
          this.$message({
            message: error,
            type: "error",
          });
          this.remoteDialogLoading = false;
        });
    },
    resetRemoteDialog() {
      this.remoteDialogLoading = false;
      this.remoteDialogModel.airValveName1 = "";
      this.remoteDialogModel.airValveName2 = "";
      this.remoteDialogModel.dataName1 = "";
      this.remoteDialogModel.dataName2 = "";
      this.remoteDialogModel.remoteCommand = false;
      this.remoteDialogModel.errorName = "";
      this.remoteDialogModel.error = "";
      this.remoteDialogModel.dataDeviceId1 = "";
      this.remoteDialogModel.dataDeviceId2 = "";
    },
    readRoute() {
      const routerPath = this.$route.fullPath.split("/");
      this.routeName = routerPath[3];

      if (this.routeName === "airValveRemote") {
        this.isRemoteAvailable = "remote-available";
      } else {
        this.isRemoteAvailable = "";
      }
    },
    getDataNameIdDict() {
      if (this.routeName === "airValveRemote") {
        return this.dataNameIdDict_remote;
      } else if (this.routeName === "airValveSwitch") {
        return this.dataNameIdDict_switch;
      } else {
        this.$message({ message: "无法识别的页面位置", type: "warning" });
        return {};
      }
    },
    getValueClassNameTranslateDict() {
      if (this.routeName === "airValveRemote") {
        return this.valueClassNameTranslateDict_remote;
      } else if (this.routeName === "airValveSwitch") {
        return this.valueClassnameTranslateDict_switch;
      } else {
        this.$message({ message: "无法识别的页面位置", type: "warning" });
        return {};
      }
    },
    getValueTooltipTranslateDict() {
      if (this.routeName === "airValveRemote") {
        return this.valueTooltipTranslateDict_remote;
      } else if (this.routeName === "airValveSwitch") {
        return this.valueTooltipTranslateDict_switch;
      } else {
        this.$message({ message: "无法识别的页面位置", type: "warning" });
        return {};
      }
    },
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      clearTimeout(this.timer);

      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          this.hasRemoteMissionInProgress = false;

          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });

          if (this.hasRemoteMissionInProgress) {
            this.timer = setTimeout(() => {
              this.getData();
            }, this.REFRESH_SECOND_REMOTE_INPROGRESS);
          } else {
            this.timer = setTimeout(() => {
              this.getData();
            }, this.REFRESH_SECOND);
          }
        })
      );
    },
    setDataAndError(stationData) {
      const dataNameIdDict = this.getDataNameIdDict();
      const valueClassNameTranslateDict = this.getValueClassNameTranslateDict();
      const valueTooltipTranslateDict = this.getValueTooltipTranslateDict();

      for (let dataName in dataNameIdDict) {
        const dataId = dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          const value = stationData[dataId].value;
          const className = valueClassNameTranslateDict[value];
          if (className === undefined) {
            this[dataName] = "";
          } else {
            this[dataName] = className;
          }

          const tooltipName = dataName.replace("Class", "Tooltip");
          const tooltip = valueTooltipTranslateDict[value];
          if (tooltip === undefined) {
            this[tooltipName] = "--";
          } else {
            this[tooltipName] = tooltip;
          }

          const errorName = this.dataNameErrorNameDict[dataName];
          if (this.isRemoteAvailable === "remote-available" && stationData[dataId].isRemoteMissionInProgress) {
            this[errorName] = "remote-in-progress";
            this.hasRemoteMissionInProgress = true;
          } else {
            if (this.dataNameErrorNameDict[dataName] !== undefined) {
              this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
            }
          }
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      const dataNameIdDict = this.getDataNameIdDict();

      for (let dataName in dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-valve-sign-default {
  0% {
    background-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    background-color: #ffff00;
  }
}
@keyframes breathee-remote-in-progress {
  0% {
    border-color: rgba(075, 160, 240, 0.3);
  }
  100% {
    border-color: #4ba0f0;
  }
}
.history-href {
  position: absolute;
  right: 50px;
  top: 50px;
}
.dialog-form-item {
  margin-bottom: 30px;
  margin-left: 60px;

  & .dialog-form-key {
    display: inline-block;
    font-weight: 700;
  }
  & .dialog-form-value {
    display: inline-block;
    margin-left: 40px;
    & p {
      margin-top: 0px;
    }
  }
  & .top-align {
    vertical-align: top;
  }
}
.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .open:after {
          background: #67dd34;
        }
        .closed:after {
          background: #a0a0a0;
        }
        .switching:after {
          background: #4ba0f0;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1030px;
        height: 320px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/image/sutong/bridgeLine.png");

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
            }
            & .segment-name {
              font-size: 13px;
              margin-bottom: 4px;
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          .remote-in-progress {
            border-color: #4ba0f0;
            animation: breathee-remote-in-progress 1500ms infinite alternate ease-in-out;
          }
          .remote-available {
            cursor: pointer;
            transition: border-color 0.3s;

            &:hover {
              border-color: #4ba0f0;
            }
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }
        .valve-sign {
          margin-top: auto;
          margin-bottom: auto;
          width: 12px;
          height: 12px;
          background-color: #ffff00;
          animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
          border-radius: 10px;

          &.open {
            background-color: #67dd34;
            animation: none;
          }
          &.closed {
            background-color: #a0a0a0;
            animation: none;
          }
          &.switching {
            background-color: #4ba0f0;
            animation: none;
          }
        }
        .left1 {
          top: 250px;
          left: 30px;
          &::before {
            bottom: 35px;
            left: -63px;
            width: 90px;
            transform: rotate(48deg);
          }
          &::after {
            bottom: 68px;
            left: -62px;
          }
          .state-info {
            right: 80px;
            top: -53px;
          }
        }

        .left1-higher {
          top: 250px;
          left: 30px;
          &::before {
            bottom: 46px;
            left: -70px;
            width: 107px;
            transform: rotate(56deg);
          }
          &::after {
            bottom: 90px;
            left: -61px;
          }
          .state-info {
            right: 79px;
            top: -75px;
          }
        }

        .left2 {
          top: 250px;
          left: 140px;
          &::before {
            bottom: 62px;
            left: -92px;
            width: 140px;
            transform: rotate(62deg);
          }
          &::after {
            bottom: 124px;
            left: -69px;
          }
          .state-info {
            right: 86px;
            top: -108px;
          }
        }

        .left3 {
          top: 250px;
          left: 250px;
          &::before {
            bottom: 95px;
            left: -114px;
            width: 190px;
            transform: rotate(72deg);
          }
          &::after {
            bottom: 185px;
            left: -62px;
          }
          .state-info {
            right: 80px;
            top: -170px;
          }
        }

        .left4 {
          top: 250px;
          left: 375px;
          &::before {
            bottom: 108px;
            left: -121px;
            width: 220px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 216px;
            left: -44px;
          }
          .state-info {
            right: 62px;
            top: -201px;
          }
        }

        .left5 {
          top: 250px;
          left: 475px;
          &::before {
            bottom: 120px;
            left: -120px;
            width: 235px;
            transform: rotate(85deg);
          }
          &::after {
            bottom: 237px;
            left: -27px;
          }
          .state-info {
            right: 44px;
            top: -222px;
          }
        }

        .right1-higher {
          top: 250px;
          right: 35px;
          &::before {
            bottom: 44px;
            left: -15px;
            transform: rotate(128deg);
            width: 100px;
          }
          &::after {
            bottom: 84px;
            left: 65px;
          }
          .state-info {
            left: 80px;
            top: -69px;
          }
        }

        .right1 {
          top: 250px;
          right: 35px;
          &::before {
            bottom: 40px;
            left: -10px;
            transform: rotate(132deg);
            width: 90px;
          }
          &::after {
            bottom: 73px;
            left: 64px;
          }
          .state-info {
            left: 80px;
            top: -58px;
          }
        }

        .right2 {
          top: 250px;
          right: 125px;
          &::before {
            bottom: 66px;
            left: -30px;
            transform: rotate(118deg);
            width: 140px;
          }
          &::after {
            bottom: 128px;
            left: 72px;
          }
          .state-info {
            left: 88px;
            top: -113px;
          }
        }

        .right3 {
          top: 250px;
          right: 225px;
          &::before {
            bottom: 94px;
            left: -58px;
            transform: rotate(108deg);
            width: 190px;
          }
          &::after {
            bottom: 185px;
            left: 65px;
          }
          .state-info {
            left: 82px;
            top: -170px;
          }
        }

        .right4 {
          top: 250px;
          right: 328px;
          &::before {
            bottom: 112px;
            left: -83px;
            transform: rotate(100deg);
            width: 220px;
          }
          &::after {
            bottom: 220px;
            left: 46px;
          }
          .state-info {
            left: 63px;
            top: -205px;
          }
        }

        .right5 {
          top: 250px;
          right: 429px;
          &::before {
            bottom: 120px;
            left: -100px;
            transform: rotate(95deg);
            width: 235px;
          }
          &::after {
            bottom: 237px;
            left: 27px;
          }
          .state-info {
            left: 44px;
            top: -222px;
          }
        }
        &.nantong {
          .left-bottom-1 {
            top: 249px;
            left: 80px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .left-bottom-2 {
            top: 249px;
            left: 195px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .left-bottom-3 {
            top: 249px;
            left: 312px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .left-bottom-4 {
            top: 249px;
            left: 425px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .right-bottom-1 {
            top: 249px;
            right: 0px;
            &::before {
              bottom: 6px;
              left: 0px;
              width: 60px;
              transform: rotate(180deg);
            }
            &::after {
              bottom: 06px;
              left: 58px;
            }
            .state-info {
              right: -134px;
              top: 9px;
            }
          }
          .right-bottom-2 {
            top: 249px;
            right: 75px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
          .right-bottom-3 {
            top: 249px;
            right: 175px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
          .right-bottom-4 {
            top: 249px;
            right: 275px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
          .right-bottom-5 {
            top: 249px;
            right: 375px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
          .right-bottom-6 {
            top: 249px;
            right: 475px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
        }
        &.changshu {
          .left-bottom-1 {
            top: 249px;
            left: -3px;
            &::before {
              bottom: 6px;
              left: -60px;
              width: 60px;
              transform: rotate(180deg);
            }
            &::after {
              bottom: 06px;
              left: -2px;
            }
            .state-info {
              left: -134px;
              top: 9px;
            }
          }
          .left-bottom-2 {
            top: 249px;
            left: 80px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .left-bottom-3 {
            top: 249px;
            left: 195px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .left-bottom-4 {
            top: 249px;
            left: 312px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .left-bottom-5 {
            top: 249px;
            left: 420px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .left-bottom-6 {
            top: 249px;
            left: 522px;
            &::before {
              bottom: -20px;
              left: -26px;
              width: 60px;
              transform: rotate(280deg);
            }
            &::after {
              bottom: -50px;
              left: -16px;
            }
            .state-info {
              right: 34px;
              top: 65px;
            }
          }
          .right-bottom-1 {
            top: 249px;
            right: 75px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
          .right-bottom-2 {
            top: 249px;
            right: 175px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
          .right-bottom-3 {
            top: 249px;
            right: 275px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
          .right-bottom-4 {
            top: 249px;
            right: 375px;
            &::before {
              bottom: -20px;
              left: -17px;
              width: 60px;
              transform: rotate(260deg);
            }
            &::after {
              bottom: -49px;
              left: 18px;
            }
            .state-info {
              right: -94px;
              top: 64px;
            }
          }
        }
      }
    }
  }
}
</style>